define('lib/layer-selector/layer-selector',[
  'app/helpers/layer-helpers',
  'lib/layer-selector/layer-selector-helpers',
  'lib/layer-selector/components/added-layers-container',
  'sortable',
], function(LayerHelpers, LayerSelectorHelpers, AddedLayersContainer, Sortable) {
  return function LayerSelector(map, availableLayers) {
    this.layers = availableLayers;
    this.addedLayers = [];

    this.setup = function() {
      this.createLayerSelector();
      this.createLayerElements(this.layers);
      this.resizeSearchResultPanel();
    };

    this.createLayerSelector = function() {
      var mapEl = document.getElementById(map._container.id);
      this.searchContainerEl = LayerSelectorHelpers.createDomElement('div', {
        id: 'ls-search-container',
        cssClass: 'ls__search-container',
      });
      this.searchInputEl = LayerSelectorHelpers.createDomElement('input', {
        id: 'ls-search-input',
        cssClass: 'ls__search-input',
        placeholder: 'Sök lager',
      });
      this.searchResultsEl = LayerSelectorHelpers.createDomElement('div', {
        id: 'ls-search-results',
        cssClass: 'ls__search-results ls--hidden',
      });
      this.addedLayersEl = LayerSelectorHelpers.createDomElement('div', {
        id: 'ls-added-layers',
        cssClass: 'ls__added-layers ls--hidden',
      });
      var searchIcon = LayerSelectorHelpers.createDomElement('i', {
        cssClass: 'ls__search-icon fas fa-search',
      });

      this.mobileTriggerEl = LayerSelectorHelpers.createDomElement('div', {
        id: 'ls-mobile-trigger',
        cssClass: 'ls__mobile-trigger ls--mobile-only',
        content: '<i class="fas fa-layer-group"></i> Lager',
        clickCallback: this.toggleLayerSelectorVisibility.bind(this, true),
      });
      this.mobileOverlayBackgroundEl = LayerSelectorHelpers.createDomElement('div', {
        id: 'ls-mobile-overlay',
        cssClass: 'ls__mobile-overlay ls--hidden',
      });

      this.setupEventListeners();

      this.searchContainerEl.appendChild(this.searchInputEl);
      this.searchContainerEl.appendChild(searchIcon);
      this.searchContainerEl.appendChild(this.searchResultsEl);
      mapEl.appendChild(this.searchContainerEl);
      mapEl.appendChild(this.addedLayersEl);
      mapEl.appendChild(this.mobileTriggerEl);
      mapEl.appendChild(this.mobileOverlayBackgroundEl);
    };

    this.setupEventListeners = function() {
      window.addEventListener('resize', this.positionGuiElements.bind(this)); // todo: add debounce

      map.on(
        'click',
        function(event) {
          var clickedTarget = event.originalEvent.target;
          if (clickedTarget.className.indexOf('leaflet-container') > -1) {
            this.toggleSearchResultsVisibility(false);
          }
        }.bind(this)
      );

      LayerSelectorHelpers.addEventListeners({
        elements: [this.searchResultsEl, this.addedLayersEl],
        events: ['mouseenter', 'click'],
        callback: function(e) {
          e.preventDefault();
          this.disableMapScroll();
          this.disableMapPan();
        }.bind(this),
      });
      LayerSelectorHelpers.addEventListeners({
        elements: [this.searchResultsEl, this.addedLayersEl],
        events: ['mouseleave'],
        callback: function(e) {
          e.preventDefault();
          this.enableMapScroll();
          this.enableMapPan();
        }.bind(this),
      });

      LayerSelectorHelpers.addEventListeners({
        elements: [this.searchContainerEl],
        events: ['mouseenter', 'focus'],
        callback: function(e) {
          e.preventDefault();
          this.searchInputEl.focus();
          this.toggleSearchResultsVisibility(true);
        }.bind(this),
      });
      LayerSelectorHelpers.addEventListeners({
        elements: [this.searchContainerEl],
        events: ['mouseleave', 'blur'],
        callback: function(e) {
          e.preventDefault();
          this.searchInputEl.blur();

          if (!this.addedLayers.length) {
            this.toggleSearchResultsVisibility(false);
          }
        }.bind(this),
      });
      LayerSelectorHelpers.addEventListeners({
        elements: [this.searchInputEl],
        events: ['keyup'],
        callback: this.filterLayers.bind(this),
      });
    };

    this.filterLayers = function(event) {
      var query = document.getElementById('ls-search-input').value;
      var filteredLayers;
      if (query.length < 4) {
        filteredLayers = this.layers;
      } else {
        filteredLayers = this.layers.filter(function(l) {
          return l.title.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }

      this.createLayerElements(filteredLayers);
    };

    this.createLayerElements = function(layers) {
      this.searchResultsEl.innerHTML = '';

      var self = this;
      layers.forEach(function(layer, index) {
        var layerEl = LayerSelectorHelpers.createDomElement('div', {
          id: 'layer-' + index,
          cssClass: 'ls__layer',
          content: layer.title,
          clickCallback: self.handleLayerClick.bind(self, layer, index),
        });
        if (self.isLayerAdded(layer)) {
          layerEl.classList.add('ls__layer--added');
        }
        self.searchResultsEl.appendChild(layerEl);
      });
      this.positionGuiElements();
    };

    this.createAddedLayerElements = function(layers) {
      this.addedLayersEl.innerHTML = '';
      var addedLayersHeader = LayerSelectorHelpers.createDomElement('header', {
        cssClass: 'ls__added-layers-header',
        content: '<i class="fas fa-layer-group"></i> Valda lager (' + layers.length + ')',
      });
      this.addedLayersEl.appendChild(addedLayersHeader);

      this.addedLayersEl.appendChild(new AddedLayersContainer(layers, this));

      this._sortable = Sortable.create(document.getElementById('ls-added-layers-container'), {
        filter: '.ls__style-container',
        preventOnFilter: false,
        onEnd: function(event) {
          var itemToMove = this.addedLayers[event.oldDraggableIndex];
          this.addedLayers.splice(event.oldDraggableIndex, 1);
          this.addedLayers.splice(event.newDraggableIndex, 0, itemToMove);

          this.reloadMapLayers(this.addedLayers);
        }.bind(this),
      });
    };

    this.isLayerAdded = function(layer) {
      var layer = this.addedLayers.find(function(l) {
        return l.title === layer.title;
      });

      return layer;
    };

    this.handleLayerClick = function(layer, index) {
      var layerAlreadyAdded = this.isLayerAdded(layer);
      if (layerAlreadyAdded) {
        this.removeLayerFromMap(layerAlreadyAdded, index);
      } else {
        this.addLayerToMap(layer, index);
      }

      this.resizeSearchResultPanel();
    };

    this.deleteAddedLayer = function(layer, index) {
      this.removeLayerFromMap(layer, index);
      this.resizeSearchResultPanel();
    };

    this.toggleLayerStyles = function(layer, index) {
      var styleContainer = document.getElementById('added-layer-styles-' + index);
      var isVisible = styleContainer.classList.contains('ls__style-container--visible');

      if (isVisible) {
        this.hideLayerStyles(layer, index);
      } else {
        styleContainer.classList.add('ls__style-container--visible');
      }
    };

    this.hideLayerStyles = function(layer, index) {
      var styleContainer = document.getElementById('added-layer-styles-' + index);
      styleContainer.classList.remove('ls__style-container--visible');
    };

    this.showLayerInfo = function(layer, index) {
      console.log('show layer info', layer, index);
    };

    this.positionGuiElements = function() {
      var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var isMobile = viewportWidth < 540;
      if (isMobile) {
        this.hideElements([
          this.addedLayersEl,
          this.searchContainerEl,
          this.searchResultsEl,
          this.mobileOverlayBackgroundEl,
        ]);
      }
      this.resizeSearchResultPanel();
    };

    this.resizeSearchResultPanel = function() {
      var marginTop = 40;
      var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var isMobile = viewportWidth < 540;
      var searchInputHeight = document.getElementById('ls-search-input').getBoundingClientRect()
        .height;
      var addedLayersHeight = document.getElementById('ls-added-layers').getBoundingClientRect()
        .height;
      document.getElementById('ls-search-results').style.maxHeight =
        viewportHeight -
        marginTop -
        addedLayersHeight -
        searchInputHeight -
        (isMobile ? 80 : 40) +
        'px';
    };

    this.addLayerToMap = function(layer, index) {
      var zIndex = 1000 + this.addedLayers.length;
      var wmsLayer = LayerHelpers.createWMSLayer(
        layer.wmslayer,
        layer.attributionText,
        layer.transparency,
        zIndex
      );
      map.addLayer(wmsLayer);
      this.addedLayers.unshift({ title: layer.title, wmsLayer: wmsLayer, index: index });
      this.toggleAddedLayersVisibility();
      this.toggleLayerAddedClass('layer-' + index, true);
    };

    this.removeLayerFromMap = function(layerToRemove) {
      map.removeLayer(layerToRemove.wmsLayer);
      var foundLayerIndex = this.addedLayers.indexOf(layerToRemove);
      this.addedLayers.splice(foundLayerIndex, 1);
      this.toggleAddedLayersVisibility();
      this.toggleLayerAddedClass('layer-' + layerToRemove.index, false);
    };

    this.reloadMapLayers = function(layers) {
      this.removeAllLayersFromMap(layers);
      this.addAllLayersToMap(layers);
    };

    this.addAllLayersToMap = function(layers) {
      layers.forEach(function(layer, index) {
        layer.wmsLayer.setZIndex(1000 - index);
        map.addLayer(layer.wmsLayer);
      });
    };

    this.removeAllLayersFromMap = function(layers) {
      layers.forEach(function(layer) {
        map.removeLayer(layer.wmsLayer);
      });
    };

    this.toggleSearchResultsVisibility = function(visible) {
      if (visible) {
        this.searchResultsEl.classList.remove('ls--hidden');
      } else {
        this.searchResultsEl.classList.add('ls--hidden');
      }
    };

    this.toggleLayerSelectorVisibility = function() {
      var isSearchContainerHidden =
        !this.searchContainerEl.style.display || this.searchContainerEl.style.display === 'none';
      if (isSearchContainerHidden) {
        this.searchContainerEl.style.display = 'block';
        document.getElementById('ls-mobile-trigger').innerHTML =
          '<i class="fas fa-check"></i> Klar';
        this.showElements([
          this.searchContainerEl,
          this.searchResultsEl,
          this.mobileOverlayBackgroundEl,
        ]);
        if (this.addedLayers.length) {
          this.showElements(this.addedLayersEl);
        }
        this.searchInputEl.focus();
        this.disableMapScroll();
        this.resizeSearchResultPanel();
      } else {
        this.searchContainerEl.style.display = 'none';
        document.getElementById('ls-mobile-trigger').innerHTML =
          '<i class="fas fa-layer-group"></i> Lager';
        this.hideElements([
          this.addedLayersEl,
          this.searchContainerEl,
          this.searchResultsEl,
          this.mobileOverlayBackgroundEl,
        ]);
        this.enableMapScroll();
      }
    };

    this.toggleAddedLayersVisibility = function() {
      this.createAddedLayerElements(this.addedLayers);
      if (this.addedLayers.length) {
        this.showElements(this.addedLayersEl);
      } else {
        this.hideElements(this.addedLayersEl);
      }
    };

    this.showElements = function(elements) {
      if (elements && !Array.isArray(elements)) {
        elements.classList.remove('ls--hidden');
        return;
      }
      elements.forEach(function(element) {
        element.classList.remove('ls--hidden');
      });
    };

    this.hideElements = function(elements) {
      if (elements && !Array.isArray(elements)) {
        elements.classList.add('ls--hidden');
        return;
      }
      elements.forEach(function(element) {
        element.classList.add('ls--hidden');
      });
    };

    this.enableMapScroll = function() {
      map.scrollWheelZoom.enable();
    };

    this.disableMapScroll = function() {
      map.scrollWheelZoom.disable();
    };

    this.enableMapPan = function() {
      map.dragging.enable();
    };

    this.disableMapPan = function() {
      map.dragging.disable();
    };

    this.toggleLayerAddedClass = function(layerId, added) {
      var layer = document.getElementById(layerId);
      if (added) {
        layer.classList.add('ls__layer--added');
      } else {
        layer.classList.remove('ls__layer--added');
      }
    };

    // instantiate plugin
    this.setup();
  };
});

